const OLD_NIT_WEIGHTS = [14, 13, 12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2] as const
const NEW_NIT_WEIGHTS = [2, 7, 6, 5, 4, 3, 2, 7, 6, 5, 4, 3, 2] as const

export const SV_NIT_DIGIT_LENGTH = 14
export const SV_NIT_FORMATTED_LENGTH = 17

export function compactSvNit(value: string): string {
  return value
    .trim()
    .toUpperCase()
    .replace(/^SV\s*/, '')
    .replace(/\D/g, '')
}

export function formatSvNit(value: string): string {
  const digits = compactSvNit(value).slice(0, SV_NIT_DIGIT_LENGTH)
  const groups = [digits.slice(0, 4), digits.slice(4, 10), digits.slice(10, 13), digits.slice(13)]
  return groups.filter(Boolean).join('-')
}

export function getSvNitMissingDigits(value: string): number {
  return Math.max(0, SV_NIT_DIGIT_LENGTH - compactSvNit(value).length)
}

function calculateSvNitCheckDigit(value: string): string | null {
  const digits = compactSvNit(value)
  const body = digits.slice(0, 13)
  if (!/^[019]\d{12}$/.test(body)) return null

  const sequence = body.slice(10, 13)
  const weights = sequence <= '100' ? OLD_NIT_WEIGHTS : NEW_NIT_WEIGHTS
  const total = weights.reduce((sum, weight, index) => sum + Number(body[index]) * weight, 0)
  const checkDigit = sequence <= '100' ? (total % 11) % 10 : ((11 - (total % 11)) % 11) % 10

  return String(checkDigit)
}

export function isValidSvNit(value: string): boolean {
  const digits = compactSvNit(value)
  if (!/^[019]\d{13}$/.test(digits)) return false
  return digits[13] === calculateSvNitCheckDigit(digits)
}
